import React from 'react';
/*
import {
  hf,
  cr,
  gs,
  ls,
  useGblz,
} from 'lib';
*/
import * as cr from './_cr';
import * as ls from "./_csLcl"; // local state

import * as icm from './icm';

import * as icvLgnD10To1 from './icvLgnD10To1';
import * as icvLgnD10To2 from './icvLgnD10To2';

export const N = (pz: {
}) => {

  const _sPz = ls.usePagez({
    steps: [0],
  });

  const _udtThis = ls.udtThis();

  React.useEffect(() => {
    icm.setLgnAsync({
      frcUdt: _udtThis,
    })
  }, []);

  return ([

    _sPz.crt.steps[0] == 0 ?
    cr.c(icvLgnD10To1.N, {
      key: -10,
      sPz: _sPz,
    })
    : null,

    _sPz.crt.steps[0] == 1 ?
    cr.c(icvLgnD10To2.N, {
      key: -20,
      sPz: _sPz,
    })
    : null,

  ]);
};
